import { FunctionalComponent, h } from '@stencil/core';
import {AppMedia, AppLink} from './'

interface SectionAssociations {
    __component: string;
    data?: any;
}


export const SectionAssociations: FunctionalComponent<SectionAssociations> = ({data}) => {

    const { Title, associations, RemoveTopMargin } = data;
    const AssociationList = associations?.data.map(({ attributes }) => attributes);

    return (
        <section class={`uk-section ${RemoveTopMargin ? 'uk-padding-remove-top' : ''}`}>
            <div class="uk-container">
                <div hidden={!Title} class="uk-text-center uk-margin-small-top">
                    <h2 class="uk-heading-small wsio-gold">{Title}</h2>
                    <hr class="uk-divder-slashed uk-width-1-2 uk-width-1-4@m uk-width-1-5@l uk-margin-medium-bottom@s" />
                </div>
                <div class="uk-text-center uk-flex-center uk-flex-middle uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-5@m" uk-grid>
                    {AssociationList.map(({ Logo, Link})=>
                        <div>
                            <AppLink className='uk-text-center' data={Link}>
                                <AppMedia media={Logo} size="(max-width: 638px) 50vw, (max-width: 958px) 25vw, 10vw" className='uk-padding-small' />
                            </AppLink>
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
};